// RAT-1684: per-region default merchant-deduction settings. Shared across the
// Regional Settings list, detail, edit pages and the Add Region modal so the field
// list, labels and help text stay in one place.
export const DEDUCTION_FIELDS = [
  {
    field: 'defaultIncludePowerbankCost',
    label: 'Deduct costs of powerbanks lost',
    short: 'Powerbanks lost',
    infoText:
      'Default for new merchants in this region. When on, lost power bank costs are deducted from commissionable revenue.',
  },
  {
    field: 'defaultIncludeCustomerPurchases',
    label: 'Deduct costs of purchased powerbanks',
    short: 'Purchased powerbanks',
    infoText:
      'Default for new merchants in this region. When on, purchased power bank costs are deducted from commissionable revenue.',
  },
  {
    field: 'defaultIncludeTransactionCost',
    label: 'Deduct transaction costs',
    short: 'Transaction costs',
    infoText:
      'Default for new merchants in this region. When on, payment processing fees are deducted before commission is calculated.',
  },
  {
    field: 'defaultIncludeEInvoiceFee',
    label: 'Deduct E-invoice fee',
    short: 'E-invoice fee',
    infoText:
      'Default for new merchants in this region. When on, the e-invoice fee is deducted before commission is calculated.',
  },
];
